module.exports = __webpack_public_path__ + "img/my-profil.7c39b1ad.jpg";